import AppConstants from '../../../../config/app.constants'
class StopSchedulingController {
    /*@ngInject*/
    constructor(Auth, $state, User, DateUtil, $translate, $q, Modal, SetupService, StopSchedulingService,
        LocationService, RouteService, UserBranchService, CommonLayoutService, Navigation, $rootScope) {
        this.DateUtil = DateUtil;
        this.Modal = Modal;
        this.SetupService = SetupService
        this.User = User;
        this.Auth = Auth;
        this.$translate = $translate;
        this.$q = $q;
        this.$state = $state;
        this.StopSchedulingService = StopSchedulingService;
        this.LocationService = LocationService;
        this.RouteService = RouteService;
        this.UserBranchService = UserBranchService;
        this.CommonLayoutService = CommonLayoutService;
        this.Navigation = Navigation;
        this.$rootScope = $rootScope;

        this.defaultModel = {
            currentBranch: User.getUser().branchId,
            loggedInUser: User.getUser().id,
            loggedInUserName: User.getUser().firstName.concat(' ', User.getUser().lastName),
            branchCurrentVaultDate: '',
            loading: false,
            branchUnassignedRoute: null,
            routeObj: {
                results: [],
                totalRoutes: 0,
                loading: false
            },
            locationObj: {
                results: [],
                totalLocation: 0,
                loading: false
            },
            stopScheduling: [],
            sameForAll: false,
            recurringPatternList: [
                {
                    label: 'Daily',
                    value: 'daily'
                },
                {
                    label: 'Weekly',
                    value: 'weekly'
                },
                {
                    label: 'Monthly',
                    value: 'monthly'
                }
            ],
            selectedPattern: 'daily',
            recurWeeks: 0,
            recurringDays: {
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false
            },
            serviceSchedule: [{
                label: 'Monday',
                value: 'monday'
            },
            {
                label: 'Tuesday',
                value: 'tuesday'
            },
            {
                label: 'Wednesday',
                value: 'wednesday'
            },
            {
                label: 'Thursday',
                value: 'thursday'
            },
            {
                label: 'Friday',
                value: 'friday'
            },
            {
                label: 'Saturday',
                value: 'saturday'
            },
            {
                label: 'Sunday',
                value: 'sunday'
            }],
            recurringMonths: {
                january: false,
                february: false,
                march: false,
                april: false,
                may: false,
                june: false,
                july: false,
                august: false,
                september: false,
                october: false,
                november: false,
                december: false,
            },
            recurringMonthObj: {
                day: {
                    dayInterval: null,
                    monthInterval: null,
                },
                month: {
                    weekInterval: null,
                    selectedWeekDay: null,
                    monthInterval: null,
                    weekIntervalList: [
                        {
                            lable: 'First',
                            value: 1
                        },
                        {
                            lable: 'Second',
                            value: 2
                        },
                        {
                            lable: 'Third',
                            value: 3
                        },
                        {
                            lable: 'Forth',
                            value: 4
                        },
                        {
                            lable: 'Fifth',
                            value: 5
                        },
                    ],
                    weekDayList: [
                        {
                            lable: 'Sunday',
                            value: 0
                        },
                        {
                            lable: 'Monday',
                            value: 1
                        },
                        {
                            lable: 'Tuesday',
                            value: 2
                        },
                        {
                            lable: 'Wednesday',
                            value: 3
                        },
                        {
                            lable: 'Thursday',
                            value: 4
                        },
                        {
                            lable: 'Friday',
                            value: 5
                        },
                        {
                            lable: 'Saturday',
                            value: 6
                        },
                    ]
                }
            },
            recurringStartDate: null,
            recurringEndDate: null,
            endRecurringAfter: null,
            dateRangeOptions: {
                startDate: null,
                endDate: null,
            },
            selectedBranch: []
        };

        this.localLang = {
            selectAll: this.$translate.instant('common.selectall'),
            selectNone: this.$translate.instant('common.selectnone'),
            reset: this.$translate.instant('shipmentBatch.reset'),
            search: this.$translate.instant('common.search'),
            nothingSelected: this.$translate.instant('branch.all_branches'),  //default-label is deprecated and replaced with this.
        }

        this.model = angular.copy(this.defaultModel);
        this.selectedMonthlyPattern = 'day';
        this.userBranchList = [];
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/stop-scheduling');
    }

    $onInit() {
        this.model.loading = true;
        this.$q.all([
            this.SetupService.get(this.model.currentBranch),
            this.UserBranchService.getUserBranches(this.model.loggedInUser)
        ])
            .then((data) => {
                this.setupDetails = data[0];
                this.userBranchList = data[1].results;
                this.userBranchList.filter((branch) => {
                    if (branch.branchId == this.setupDetails.branchId) {
                        branch.ticked = true;
                    }
                });

                this.model.formattedvaultDate = this.DateUtil.convertToDate(this.setupDetails.currentVaultDate);
                this.model.branchUnassignedRoute = this.setupDetails.unassignedRouteId ? { Key: this.setupDetails.unassignedRoute.id + ' | ' + this.setupDetails.unassignedRoute.name, Value: this.setupDetails.unassignedRoute.id } : null;
                this.cloneBranchUnassignedRoute = this.model.branchUnassignedRoute;
                this.loadLocation('', 0);
                this.loadRoutes('', 0);
                this.model.stopScheduling.push({
                    route: this.model.branchUnassignedRoute,
                    location: null,
                    status: 'create'
                })
                this.validateRecurringStartDate();
                this.setDateRange();
                this.getPendingChanges();
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                this.model.loading = false;
            })
    }

    setDateRange() {
        this.loadDateRangePicker(this.model.dateRangeOptions, 'dateRange');
        this.model.dateRangeOptions.startDate = moment().subtract(10, 'days').format('YYYY-MM-DD HH:mm:ss');
        this.model.dateRangeOptions.endDate = moment();
    }

    loadDateRangePicker(dateRangeOption, modelVal) {
        this.model[modelVal] = {
            autoApply: true,
            eventHandlers: {
                'apply.daterangepicker': () => {
                    this.getPendingChanges();
                }
            },
            ranges: {
                'Running 10 Days': [
                    moment().subtract(10, 'days').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Today': [
                    moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Week': [
                    moment().startOf('week').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('week').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Month': [
                    moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
                ]
            }
        }
    }

    getStartDate() {
        return this.model.dateRangeOptions.startDate ? moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD 00:00:00') : null;
    }

    getEndDate() {
        return this.model.dateRangeOptions.endDate ? moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59') : null;
    }

    loadLocation(searchKey, offset) {
        searchKey = searchKey || '';

        const searchObj = {
            queryJSON: {
                rules: [{
                    field: 'branchId',
                    condition: '=',
                    data: this.model.currentBranch
                },
                {
                    field: 'locationType',
                    condition: '!=',
                    data: 'TANKER',
                },
                {
                    field: 'locationType',
                    condition: '!=',
                    data: 'TRUCK',
                },
                {
                    field: 'locationType',
                    condition: '!=',
                    data: 'WINDOW',
                },
                {
                    field: 'active',
                    condition: '=',
                    data: true
                },
                {
                    group: {
                        rules: [{
                            field: 'id',
                            condition: 'like',
                            data: '%' + searchKey + '%'
                        },
                        {
                            field: 'name',
                            condition: 'like',
                            data: '%' + searchKey + '%'
                        }
                        ],
                        operator: 'OR'
                    }
                }],
                operator: 'AND'
            },
        };

        this.model.locationObj.loading = true;
        this.LocationService.all(searchObj, offset, AppConstants.defaultPageLimit)
            .then((res) => {
                if (offset === 0) {
                    this.model.locationObj.totalLocation = res.total;
                    this.model.locationObj.results = this.mappingData(res.results, 'name', 'id');
                } else {
                    const locations = this.mappingData(res.results, 'name', 'id');
                    this.model.locationObj.results = this.model.locationObj.results.concat(locations);
                }
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                this.model.locationObj.loading = false;
            })
    }

    loadRoutes(searchKey, offset) {
        searchKey = searchKey || '';

        const searchObj = {
            queryJSON: {
                rules: [
                    {
                        field: 'branchId',
                        condition: '=',
                        data: this.model.currentBranch
                    },
                    {
                        field: 'holdRoute',
                        condition: '=',
                        data: false
                    },
                    {
                        group: {
                            rules: [{
                                field: 'id',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            },
                            {
                                field: 'name',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }
                            ],
                            operator: 'OR'
                        }
                    }
                ],
                operator: 'AND'
            }
        }

        this.model.routeObj.loading = true;
        return this.RouteService.all(searchObj, offset, AppConstants.defaultPageLimit)
            .then((res) => {
                if (offset === 0 || offset == undefined) {
                    this.model.routeObj.totalRoutes = res.total;
                    this.model.routeObj.results = this.mappingData(res.results, 'name', 'id');
                } else {
                    const routes = this.mappingData(res.results, 'name', 'id');
                    this.model.routeObj.results = this.model.routeObj.results.concat(routes);
                }
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                this.model.routeObj.loading = false;
            })
    }

    mappingData(arr, label, value) {
        return arr.map((item) => {
            const arrayObject = {
                Key: item[value] + ' | ' + item[label],
                Value: item[value],
                dataObj: item
            };

            return arrayObject;
        });
    }

    addNewRecord() {
        this.isValid = true;

        // if (this.model.sameForAll) return;
        this.model.stopScheduling.map((denom) => {
            if (denom.route == null || denom.location == null) this.isValid = false;
        });

        if (this.isValid) this.add();
    }

    add() {
        this.model.stopScheduling.push({
            route: !this.model.sameForAll ? this.model.branchUnassignedRoute : this.model.stopScheduling[0].route,
            location: null,
            status: 'create'
        });
    }

    removeRecords(index) {
        this.model.stopScheduling.splice(index, 1);
    }

    selectedPattern(pattern) {
        this.model.selectedPattern = pattern.value;
    }

    resetRecurringData() {
        Object.keys(this.model.recurringMonths).filter((key) => {
            return this.model.recurringMonths[key] = false;
        });
        this.model.recurWeeks = 0;
    }

    getMonthlyPattern(pattern) {
        this.selectedMonthlyPattern = pattern;
    }

    sameForAll() {
        setTimeout(() => {
            if (this.model.sameForAll) {
                this.model.stopScheduling.forEach((stop) => {
                    stop.route = null;
                })
            }
        })
    }

    updateRoutes(seletedValue) {
        if (this.model.sameForAll) {
            this.model.stopScheduling.forEach((stop) => {
                stop.route = seletedValue;
            })
        }
    }

    validateRecurringBtn() {
        let isValidDay = false;

        Object.keys(this.model.recurringDays).filter((key) => {
            if (this.model.recurringDays[key]) isValidDay = true;
        });

        return (this.model.recurringStartDate && (this.model.recurringEndDate || this.model.endRecurringAfter) &&
            this.model.selectedPattern === 'weekly' ? isValidDay : true) || 'isEmpty'
    }

    toggleDay(day) {
        this.model.recurringDays[day.value] = !this.model.recurringDays[day.value];
    }

    isDaySelected(day) {
        return this.model.recurringDays[day.value];
    }

    validateRecurringStartDate() {
        this.minRecurrStartDate = {
            minDate: moment(),
            maxDate: moment(this.model.recurringStartDate).add(1, 'years')
        };
        this.model.recurringStartDate = this.minRecurrStartDate.minDate;
    }

    validateEndDate() {
        this.minRecurrDate = {
            // minDate: moment(this.model.recurringStartDate).add(1, 'days'),
            maxDate: moment(this.model.recurringStartDate).add(1, 'years')
        };

        if (this.model.recurringEndDate && moment(this.model.recurringStartDate).isAfter(this.model.recurringEndDate)) {
            this.model.recurringEndDate = moment(this.model.recurringStartDate).add(1, 'days');
        }
    }

    confirmRecurring() {
        this.Modal.confirm({
            header: this.$translate.instant('common.confirm_title'),
            message: this.$translate.instant('branch_mgmt.stop_scheduling.confirm_recurring'),
            callback: (({
                modal
            }) => {
                this.isCommit = false;
                modal.close();
                this.createRecurring(modal);
            }),
            negative: (({
                modal,
            }) => {
                modal.close();
                this.isCommit = false;
            }),
            buttons: ['common.ok', 'common.cancel'],
            type: 'success'
        })
    }

    createRecurring(modal) {
        let weeklyRecurring = {}, monthlyRecurring_the = {}, monthlyRecurring_day = {}, scheduledStops = [];

        this.model.stopScheduling.forEach(s => {
            scheduledStops.push({
                locationId: s.location.Value,
                locationKey: s.location.Key,
                routeId: s.route.Value,
                routeKey: s.route.Key,
                locationAddress: this.formatAddress(s.location.dataObj),
                stopPriority: s.location.dataObj.stopPriority,
                locationType: s.location.dataObj.locationType,
                locationName: s.location.dataObj.name
            })
        })

        const obj = {
            createdByUserId: this.model.loggedInUser,
            createdByUserName: this.model.loggedInUserName,
            branchId: this.model.currentBranch,
            recurringStartDate: moment(this.model.recurringStartDate).format('YYYY-MM-DD 00:00:00'),
            recurringEndDate: this.model.recurringEndDate ? moment(this.model.recurringEndDate).format('YYYY-MM-DD 23:59:59') : null,
            selectedPattern: this.model.selectedPattern,
            recurringDayInterval: this.model.recurringDayInterval,
            endRecurringAfter: this.model.endRecurringAfter,
            scheduledStops
        };

        obj.recurringFrequency = this.recurringFrequency(this.model.selectedPattern, this.model.recurWeeks, this.model.recurringMonthObj);

        if (this.model.selectedPattern === 'weekly') {
            weeklyRecurring = {
                recurWeeks: this.model.recurWeeks,
                recurringDays: Object.keys(this.model.recurringDays).filter((key) => {
                    return this.model.recurringDays[key]
                }),
            };
            const weekDays = weeklyRecurring.recurringDays.map((rd) => rd.charAt(0).toUpperCase() + rd.slice(1));
            weeklyRecurring.scheduleWeekDays = weekDays.splice(',').join(' | ');
            obj.weeklyRecurring = weeklyRecurring;
        }

        if (this.model.selectedPattern === 'monthly' && this.selectedMonthlyPattern === 'the') {
            monthlyRecurring_the = {
                weekInterval: this.model.recurringMonthObj.month.weekInterval,
                selectedWeekDay: this.model.recurringMonthObj.month.selectedWeekDay,
                monthInterval: this.model.recurringMonthObj.month.monthInterval,
                frequencyMonth: this.model.recurringMonthObj.month.frequencyMonth,
                frequencyWeek: this.model.recurringMonthObj.month.frequencyWeek,
            };
            obj.recurringMonthObj = monthlyRecurring_the;
        }

        if (this.model.selectedPattern === 'monthly' && this.selectedMonthlyPattern === 'day') {
            monthlyRecurring_day = {
                selectedMonthlyPattern: this.selectedMonthlyPattern,
                dayInterval: this.model.recurringMonthObj.day.dayInterval,
                monthInterval: this.model.recurringMonthObj.day.monthInterval,
                frequencyMonth: this.model.recurringMonthObj.day.frequencyMonth,
                frequencyDay: this.model.recurringMonthObj.day.frequencyDay
            };
            obj.recurringMonthObj = monthlyRecurring_day;
        }

        obj.selectedMonthlyPattern = this.selectedMonthlyPattern;
        this.model.isCreateRecurring = true;
        this.StopSchedulingService.createStopScheduling(obj)
            .then(() => {
                this.resetData();
                this.getPendingChanges();
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                if (modal) modal.close();
                this.model.isCreateRecurring = false;
            })
    }

    recurringFrequency(selectedPattern = null, recurWeeks = 0, recurringMonthObj) {
        const weeks = { 1: 'Every 1st Week', 2: 'Every 2nd Week', 3: 'Every 3rd Week', 4: 'Every 4th Week' };
        const dayOfWeekObj = { 0: 'sunday', 1: 'monday', 2: 'tuesday', 3: 'wednesday', 4: 'thursday', 5: 'friday', 6: 'saturday' };

        switch (selectedPattern) {
            case 'daily': {
                return 'Daily';
            }
            case 'weekly': {
                return weeks[recurWeeks];
            }
            case 'monthly': {
                if (this.selectedMonthlyPattern === 'day') {
                    recurringMonthObj.day.frequencyMonth = `${this.CommonLayoutService.ordinalSuffixOf(recurringMonthObj.day.monthInterval)} Month`;
                    recurringMonthObj.day.frequencyDay = `${this.CommonLayoutService.ordinalSuffixOf(recurringMonthObj.day.dayInterval)} Day`;
                    return `Monthly`;
                }
                else if (this.selectedMonthlyPattern === 'the') {
                    recurringMonthObj.month.frequencyMonth = `${this.CommonLayoutService.ordinalSuffixOf(recurringMonthObj.month.monthInterval)} Month`;
                    recurringMonthObj.month.frequencyWeek = `${weeks[recurringMonthObj.month.weekInterval]} (${dayOfWeekObj[recurringMonthObj.month.selectedWeekDay]})`;
                    return `Monthly`;
                }
            }
            default: return;
        }
    }

    resetData() {
        this.model = angular.copy(this.defaultModel);
        this.model.branchUnassignedRoute = this.cloneBranchUnassignedRoute;
        this.userBranchList.filter((branch) => {
            if (branch.branchId == this.setupDetails.branchId) {
                branch.ticked = true;
                this.model.selectedBranch.push(branch);
            }
            else {
                branch.ticked = false;
            }
        });

        this.loadLocation('', 0);
        this.loadRoutes('', 0);
        this.setDateRange();
        this.validateRecurringStartDate();
        this.addNewRecord();
        this.getPendingChanges();
    }

    getPendingChanges() {
        this.pendingChangesObj = {
            results: [],
            loading: false,
            currentPage: 1,
            maxPages: 10,
            filteredResults: [],
            pageLimit: 10,
            page: 1,
            totalRecords: 0,
            loading: false
        }
        setTimeout(() => {
            const startDate = this.getStartDate();
            const endDate = this.getEndDate();
            const searchText = this.model.searchText;
            const branchId = this.getSelectedBranches();

            this.pendingChangesObj.loading = true;
            this.StopSchedulingService.getPendingChanges(startDate, endDate, branchId, searchText)
                .then((data) => {
                    this.pendingChangesObj.results = data.results;
                    this.pendingChangesObj.totalRecords = data.results.length;
                    this.paginator();
                })
                .catch((err) => {
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message);
                    }
                })
                .finally(() => {
                    this.pendingChangesObj.loading = false;
                    setTimeout(() => {
                        const el = document.getElementById('stopSchedulingSearch');
                        if (el) el.focus();
                    }, 100);
                })
        });
    }

    cancelScheduledStops(jobKey, event) {
        this.model.deleteStopRecurring = true;
        this.Modal.confirm({
            header: this.$translate.instant('errorModal.title'),
            message: this.$translate.instant(`verifyHoldShipments.forceCloseShipments`),
            callback: (({
                modal
            }) => {
                this.StopSchedulingService.cancelScheduledStops(jobKey)
                    .then(() => {
                        this.getPendingChanges();
                        event.preventDefault();
                    })
                    .catch((err) => {
                        if (err && err.data && err.data.message) {
                            this.Modal.errorModal(err.data.message);
                        }
                    })
                    .finally(() => {
                        this.model.deleteStopRecurring = false;
                    })
                modal.close();
            }),
            buttons: ['common.ok', 'common.cancel'],
            type: 'danger'
        })
    }

    paginator() {
        let begin = ((this.pendingChangesObj.currentPage - 1) * this.pendingChangesObj.maxPages);
        let end = begin + this.pendingChangesObj.maxPages;
        this.pendingChangesObj.filteredResults = this.pendingChangesObj.results.slice(begin, end);
    }

    nextPage() {
        let begin = ((this.pendingChangesObj.page - 1) * this.pendingChangesObj.maxPages);
        let end = begin + this.pendingChangesObj.maxPages;
        this.pendingChangesObj.filteredResults = this.pendingChangesObj.results.slice(begin, end);
    }

    splitKey(key) {
        if (!key) return;
        return key.split(' | ')[1];
    }

    editLocation(locationId) {
        this.Navigation.goToLocationTab(locationId);
    }

    getSelectedBranches() {
        return Array.isArray(this.model.selectedBranch) ? this.model.selectedBranch.map((branch) => branch.branchId) : null;
    }

    capitalizeFirstLetter(value) {
        if (typeof value !== 'string') return;
        else return value.charAt(0).toUpperCase() + value.slice(1);
    }

    refreshPendingChanges(event) {
        this.getPendingChanges();
        event.preventDefault();
    }

    formatAddress(data) {
        let locationAddress = '';
        if (data.address) locationAddress = locationAddress.concat(data.address, ', ');
        if (data.city) locationAddress = locationAddress.concat(data.city, ', ');
        if (data.zip) locationAddress = locationAddress.concat(data.zip, ', ');
        if (data.state) locationAddress = locationAddress.concat(data.state, ', ');
        if (data.country) locationAddress = locationAddress.concat(data.country);
        return locationAddress;
    }
}

export default StopSchedulingController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/stop_scheduling/stop_scheduling.controller.js